import React, { memo } from "react";
import cn from "classnames";

import { Option } from "types/common";

type Props = {
  optionLeft: Option;
  optionRight: Option;
  selectedOption: Option;
  onClick: () => void;
};

export const Toggle = memo(
  ({ optionLeft, optionRight, selectedOption, onClick }: Props) => {
    return (
      <button
        type="button"
        className="flex items-center px-4 py-1  bg-border rounded-[8px] text-[12px] z-[2] relative overflow-hidden transition-all"
        onClick={onClick}
      >
        <p>{optionLeft.label}</p>
        <p className=" ml-10">{optionRight.label}</p>
        <div
          className={cn(
            "min-w-[45%] px-5 py-0.5 rounded-[6px] bg-white shadow-sm absolute transition-all",
            {
              "left-[1%]": selectedOption.value === optionLeft.value,
              "left-[53%]": selectedOption.value === optionRight.value,
            }
          )}
        >
          {selectedOption.value === optionLeft.value
            ? optionLeft.label
            : optionRight.label}
        </div>
      </button>
    );
  }
);
